var $9d9ea1aecb88a425$exports = {};
$9d9ea1aecb88a425$exports = {
    "maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "minimum": `\u{41C}\u{456}\u{43D}\u{456}\u{43C}\u{443}\u{43C}`
};


export {$9d9ea1aecb88a425$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
